import { useEffect, useState } from 'react';

export function usePreppedAnswerUpdates({
    defaultTab,
    fetchRoles,
    history,
    isLoading,
    permissionKey,
}) {
    const [data, setData] = useState({ skus: [], packages: [] });
    const [error, setError] = useState('');
    const [activeTab, setActiveTab] = useState(defaultTab);

    useEffect(() => {
        async function fetchData() {
            try {
                isLoading(true);
                const rolesResponse = await fetchRoles({
                    permissionKey,
                });
                const userRoleIds = rolesResponse.roles?.map(({ id }) => id);
                setData({ userRoleIds });
            } catch (err) {
                setError(err);
            } finally {
                isLoading(false);
            }
        }
        fetchData();
    }, [fetchRoles, isLoading, permissionKey]);

    return {
        activeTab,
        error,
        setActiveTab,
        userRoleIds: data.userRoleIds,
    };
}
